import React from 'react';

import {fetchFormMetadata} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';
import memoizePromise from '../../misc/memoizePromise';

const LoadEventFormsMetadata = ({eventId, children}) => {
    useStoredDataChanged();
    return (
        <Loader
            skipSpinner={state => !state.events[eventId]?.event.forms?.find(id => !state.forms.metadata[id])}
            promises={_(app.store.getState())
                .get(`events[${eventId}].event.forms`, [])
                .map(form => fetchFormMetadata(form.id))}>
            {children}
        </Loader>
    );
};

export default LoadEventFormsMetadata;
